import "./Player.scss";

import React, { useCallback, useState } from "react";

import Card from "../../CustomComponents/Card";
import MapPin from "./MapPin";
import { Player } from "../../CustomComponents/Player";
import { products } from "./products";

const Home = props => {
  const [playing, setPlaying] = useState(false);
  const [url, setUrl] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [active, setActive] = useState({});
  const [page, setPage] = useState("");

  const handleEnded = useCallback(() => {
    setPlaying(false);
    props.history.push(`/product/${page}`);
  }, [props, page]);

  const loadScene = useCallback((scene, p) => {
    window.jQuery("#sidebar").collapse("hide");
    setUrl(scene.src);
    setShowResults(true);
    setPlaying(true);
    setPage(p);
  }, []);

  const atleastOneActive = Object.values(active).some(val => val);

  return (
    <div className="app">
      <section className="section">
        <div className="custom-homepage-image">
          <div className="custom-player-wrapper">
            <Player
              url={url}
              playing={playing}
              setPlaying={setPlaying}
              handleEnded={handleEnded}
              frameImg="../../assets/Raw-Water-Transfer/Start-Frame.png"
            >
              {!showResults && (
                <>
                  <div className="pins">
                    {products.map(product => (
                      <MapPin
                        key={product.id}
                        img={product.img}
                        text={product.text}
                        active={active[product.id]}
                        atleastOneActive={atleastOneActive}
                        style={product.position}
                        setActive={val =>
                          setActive({ ...active, [product.id]: val })
                        }
                        onClick={() => loadScene(product.scene, product.page)}
                      />
                    ))}
                  </div>
                  <div className="hover-text">
                    {products.map(product => (
                      <div
                        key={product.id}
                        className={
                          "custom-snapshot" +
                          (active[product.id] ? " active" : "") +
                          (product.position.top
                            ? " positive-y"
                            : " negative-y") +
                          (product.position.left
                            ? " positive-x"
                            : " negative-x")
                        }
                        style={product.position}
                      >
                        <Card
                          name={product.name}
                          img={product.img}
                          text={product.text}
                        ></Card>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </Player>
          </div>
        </div>

        <div className={showResults ? "hidden" : "Home-title Title-color"}>
          
          <div className="desktop-log-set">
            <a href="https://www.fluidlinesystems.com/" class="logo-container">
            <div className="logo-container">
              
                
                  <img
                className="desktop-logo fluid-log"
                src="../../../assets/logo/fl_new_trans.png"
                alt="Fluidline logo"
              />
               
                       
            </div>
            </a>
          </div>
          
        </div>
        <div
          className="collapse navbar-collapse width sidebar-content"
          id="sidebar"
        >
          <nav className="navbar navbar-dark">
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#sidebar"
              aria-controls="sidebar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </nav>
          <div className="bg-white nav-items">
            {products.map(product => (
              <li
                key={product.id}
                onMouseOver={() => setActive({ ...active, [product.id]: true })}
                onMouseOut={() => setActive({ ...active, [product.id]: false })}
                onClick={() => loadScene(product.scene, product.page)}
                className={active[product.id] ? "active" : ""}
              >
                {product.name}
              </li>
            ))}
          </div>
        </div>
      </section>
      {products.map(product => (
        <img
          key={product.id}
          className="preload-img"
          alt="Preload"
          loading="lazy"
          src={product.productImage}
        />
      ))}
    </div>
  );
};

export default Home;
